import React from 'react';
import { benefits } from '../data/salesContent';
import { images } from '../data/siteConfig';
export function MainGuideSection() {
  return <section className="bg-mist py-16 lg:py-24" data-id="element-98" data-mp="3qek60q691y6z">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-[0.85fr_1.15fr]" data-id="element-99" data-mp="7z9nq4zsesz8">
        <div data-id="element-100" data-mp="37hwrtcpyl8k">
          <h2 className="font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-101" data-mp="36ylgvhkqv3i">
            Meet Your New Poolside Reference
          </h2>
          <img src={images.bundleMockup} alt="The Homeowner’s Pool Care Guide" className="mt-8 aspect-[3/4] w-full max-w-sm rounded-3xl object-cover object-[56%_center]" data-id="element-102" data-mp="cxt8w36k40qj" />
          <p className="mt-6 font-display text-xl font-extrabold uppercase tracking-wide text-navy" data-id="element-103" data-mp="lxzl7lqiquo4">
            Pool Care Made Simple
          </p>
          <p className="font-medium text-aqua" data-id="element-104" data-mp="2sp7cc11bh3yw">The Homeowner’s Pool Care Guide</p>
          <p className="mt-3 max-w-md text-lg leading-relaxed text-ink" data-id="element-105" data-mp="2nr5svezzb2mw">
            A 40-page visual PDF that helps you understand your pool and organize its everyday care.
          </p>
        </div>

        <ul className="grid gap-x-8 gap-y-8 sm:grid-cols-2" data-id="element-106" data-mp="2dh6cu3e5qbqd">
          {benefits.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4" data-id="element-107" data-mp="2idofmxpxg002">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-aqua" data-id="element-108" data-mp="2n6pzlk4zqpqi">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-109" data-mp="2r79u0fy6jf8y" />
              </span>
              <div data-id="element-110" data-mp="2w6cwptqot9dr">
                <h3 className="font-display text-lg font-bold leading-snug text-navy" data-id="element-111" data-mp="2w5l2am8tthp2">{title}</h3>
                <p className="mt-1 leading-relaxed text-ink" data-id="element-112" data-mp="316saunismkws">{text}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}